module.exports = __webpack_public_path__ + "img/thank.71fa3d88.jpeg";